<template>
  <div id="app">
      <div style="display: none;">{{languageCode}}</div>
      <router-view v-if="isLoadedLanguage"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isLoadedLanguage:false
    }
  },
  computed:{
    languageCode(){
      this.loadJson("./static/language/language-"+this.$store.state.languageCode+".json").then(res=>{
        this.$store.commit('update',["language",res])
        this.isLoadedLanguage = true
      }).catch(err=>{
        console.log("load language err: "+err)
      })
    }
  },
  created() {
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue